// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2":"efdc8eb7","193":"3e7488fd"}[chunkId] + ".css";
};